import { Routes } from '@angular/router';
import { authenticatedGuard } from '@guards/authenticated.guard';

export const benefitsRoutes: Routes = [
  {
    canActivate: [authenticatedGuard],
    data: { key: 'benefits' },
    loadComponent: () => import('./benefits/benefits.page').then((m) => m.BenefitsPage),
    path: '',
    title: 'Dashboard Beneficios | Mundo Hogar',
  },
  {
    canActivate: [authenticatedGuard],
    data: { key: 'benefit-details' },
    loadComponent: () => import('./benefit-details/benefit-details.page').then((m) => m.BenefitDetailsPage),
    path: ':benefitId',
    title: 'Dashboard Detalles del beneficio | Mundo Hogar',
  },
];
